import {
  type ParseOptions,
  canonicalPath,
  RouteParseError,
} from '@noths/polaris-product-listings-urls';

/**
 * {@link canonicalPath}, but returns `null` instead of throwing when `url` cannot
 * be parsed under `options`. The shared non-throwing wrapper for the webapp's
 * canonicalisation call sites (match keys, the canonical tag, redirect
 * canonicalisation) so the `RouteParseError` handling lives in one place.
 */
export const safeCanonicalPath = (url: string, options: ParseOptions): string | null => {
  try {
    return canonicalPath(url, options);
  } catch (error) {
    if (error instanceof RouteParseError) {
      return null;
    }
    throw error;
  }
};
